module.exports = "/assets/data/525af086f8c03fd0cffa75a78f10bef3-IP5.data.json";